import {
  EMPTY_FUNCTION,
  EMPTY_LIST,
  EMPTY_OBJECT,
} from '../../../../constants/common'
import { GretaAIChatChatListProject } from '../GretaAIChatChatListProject'

import * as styles from './GretaAIChatChatListProjectsList.module.css'

function GretaAIChatChatListProjectsList({
  activeChatId,
  chatStatusById = EMPTY_OBJECT,
  expandedProjectIds = EMPTY_LIST,
  fullProjectIds = EMPTY_LIST,
  locale,
  now,
  projects = EMPTY_LIST,
  withRowActions = true,
  onSelectChat = EMPTY_FUNCTION,
  onShowAllChats = EMPTY_FUNCTION,
  onToggleProject = EMPTY_FUNCTION,
}) {
  return (
    <ul className={styles.list}>
      {projects.map(project => (
        <GretaAIChatChatListProject
          activeChatId={activeChatId}
          chatStatusById={chatStatusById}
          isExpanded={expandedProjectIds.includes(project.id)}
          isFull={fullProjectIds.includes(project.id)}
          key={project.id}
          locale={locale}
          now={now}
          project={project}
          withRowActions={withRowActions}
          onSelectChat={onSelectChat}
          onShowAllChats={onShowAllChats}
          onToggle={onToggleProject}
        />
      ))}
    </ul>
  )
}

export default GretaAIChatChatListProjectsList
